import { memo, useEffect, useState } from "react";
import { Handle, Position, type NodeProps } from "@xyflow/react";
import {
  assetAvailability,
  assetThumbnailUrl,
  type ImageFlowNode
} from "./node-types.js";
import { useMeasuredHandles } from "./useMeasuredHandles.js";
import { canvasCopy } from "../../copy/zh-CN.js";

export const ImageNode = memo(function ImageNode({
  id,
  data,
  selected
}: NodeProps<ImageFlowNode>) {
  useMeasuredHandles(id, data.refreshHandles);
  const [mediaFailed, setMediaFailed] = useState(false);
  useEffect(() => setMediaFailed(false), [data.asset?.updatedAt, data.canvasNode.assetId]);
  const availability = assetAvailability(data.asset, mediaFailed);
  const previewEnabled = data.previewEnabled !== false;
  return (
    <article className={`asset-node asset-node--image${selected ? " asset-node--selected" : ""}`}>
      <Handle type="target" position={Position.Left} />
      <header><span>{canvasCopy.imageNode}</span><strong>{data.asset?.displayName ?? data.label}</strong></header>
      {(availability === "available" || availability === "unknown") && previewEnabled ? (
        <img
          src={data.previewUrl ?? assetThumbnailUrl(data.canvasNode.assetId)}
          alt={data.asset?.displayName ?? canvasCopy.imageNode}
          draggable={false}
          data-media-preview
          onError={() => setMediaFailed(true)}
        />
      ) : (
        <p className="asset-node__status" role="status">
          {!previewEnabled ? canvasCopy.mediaPreviewOmitted : availability === "trashed" ? canvasCopy.imageInTrash : canvasCopy.imageUnavailable}
        </p>
      )}
      <Handle type="source" position={Position.Right} />
    </article>
  );
});
